// extracted by mini-css-extract-plugin
export default {"metric":"styles_metric__SiKcL"};